import { render, staticRenderFns } from "./CollaborateForm.vue?vue&type=template&id=5cce4bdc&scoped=true&"
import script from "./CollaborateForm.vue?vue&type=script&lang=js&"
export * from "./CollaborateForm.vue?vue&type=script&lang=js&"
import style0 from "./CollaborateForm.vue?vue&type=style&index=0&id=5cce4bdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cce4bdc",
  null
  
)

export default component.exports